export default __webpack_public_path__ + "static/media/feature_købispil.a4dc94bc.jpg";